import GraduationCapIcon from './GraduationCapIcon'

export default GraduationCapIcon
